import Select from "react-select";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { Input, UncontrolledTooltip } from "reactstrap";

const productFeaturedTooltip =
  "Type the names of your products that are featured in the video. This video will then be analyzed and included in this products’ filters and reports.";
const notesTooltip =
  "Notes are for internal use. You can filter videos later by whether or not you’ve added a note.";

const infoIcon =
  require(`@src/assets/images/vyrill/icons/information_icon.png`).default;

const VideoDetails = ({
  singleVideoDetail,
  handleChangeProduct,
  selectCompetitors,
  productsOption,
  onChangeNotes,
  validationErrors,
  handleChangeCategory,
}) => {
  const [categoriesOption, setCategoriesOption] = useState([]);

  const { addCompetitorVideo } = useSelector((state) => state.videoData);
  const competitor_brands =
    useSelector((state) => state.home.competitor_brands) || [];
  const productsCategories = useSelector(
    (state) => state.autoCompleteProductOrHashtagCategories.data
  );

 const fieldStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: "#C7C6C6",
      minHeight: "66px",
      boxShadow: null,
      borderRadius: "10px",
      "&:hover": {
        borderColor: "#C4C4C4",
      },
    }),
  
    valueContainer: (provided) => ({
      ...provided,
    }),
  
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: "#D9D9D9",
        borderRadius: "6px",
        marginRight: "1px",
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
    }),
  
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        color: "black",
        backgroundColor: "white",
      };
    },
  };

  useEffect(() => {
    if (productsCategories) {
      const categories = productsCategories.map((k) => ({
        label: k.name ? k.name.charAt(0).toUpperCase() + k.name.slice(1) : "",
        value: k.id,
      }));
      // Sort the categories alphabetically by label
      categories.sort((a, b) => a.label.localeCompare(b.label));
      setCategoriesOption(categories);
    }
  }, [productsCategories]);

  const toolTipFunction = (message, target) => (
    <UncontrolledTooltip
      className="Step2FetchDetails"
      placement="right"
      target={target}
      style={{ backgroundColor: "#E4F9F7", color: "black" }}
    >
      {message}{" "}
    </UncontrolledTooltip>
  );

  return (
    <div>
      {addCompetitorVideo && (
        <div>
          <div className="field-headings" style={{ marginBottom: "7px" }}>
            <span>Competitor Brand Name</span>
          </div>
          <CreatableSelect
            onChange={selectCompetitors}
            value={singleVideoDetail?.competitors || []}
            options={competitor_brands.map((i) => ({ label: i, value: i }))}
            isMulti
            components={{
              DropdownIndicator: () => null,
              IndicatorSeparator: () => null,
            }}
            styles={fieldStyles}
            placeholder="Type here…"
          />
          <div className="position-absolute field-input-error form-text text-muted">
            {validationErrors.competitor}{" "}
          </div>
        </div>
      )}
      <div>
        <div className="field-headings" style={{ marginBottom: "7px" }}>
          <span>Products Featured</span>
          <span id="ProductsName" className="ms-1">
            <img src={infoIcon} width={12} />
          </span>
          {toolTipFunction(productFeaturedTooltip, "ProductsName")}
        </div>

        <CreatableSelect
          isClearable
          isMulti
          onChange={handleChangeProduct}
          options={productsOption}
          placeholder="Type here…"
          value={singleVideoDetail.selectedProducts}
          styles={fieldStyles}
          components={{
            DropdownIndicator: () => null,
            IndicatorSeparator: () => null,
          }}
        />
      </div>
      <div>
        <div
          className="field-headings"
          style={{ marginBottom: "7px", marginTop: "40px" }}
        >
          <span style={{ fontSize: "16px" }}>Product Category</span>
        </div>
        <div>
          <Select
            onChange={handleChangeCategory}
            value={singleVideoDetail.productCategory}
            options={categoriesOption}
            components={{ IndicatorSeparator: () => null }}
            styles={fieldStyles}
            placeholder="Type here…"
          />
          <div className="position-absolute field-input-error form-text text-muted">
            {validationErrors.tagValueError}{" "}
          </div>
        </div>
      </div>
      {!addCompetitorVideo && (
        <div>
          <div
            className="field-headings"
            style={{ marginBottom: "7px", marginTop: "40px" }}
          >
            <span>Notes</span>
            <span id="Notes" className="ms-1">
              <img src={infoIcon} width={12} />
            </span>
            {toolTipFunction(notesTooltip, "Notes")}
          </div>
          <div>
            <Input
              type="text"
              name="url"
              id="url"
              onChange={onChangeNotes}
              value={singleVideoDetail.notes}
              style={{
                marginTop: "7px",
                borderRadius: "10px",
                minHeight: "66px",
                border: "1px solid #d9d9d9",
              }}
            />
            <div className="position-absolute field-input-error form-text text-muted">
              {validationErrors.notesError}{" "}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoDetails;
